import React from "react";
import siteText from "../assets/siteText.json";
import { buildSrcSets } from "../utils/imageSrcSet";
import "./Home.css";

const text = siteText.home;
const photoSizes = "(max-width: 600px) 100vw, 450px";

function Photo({ base, widths, fallback, alt, width, height }) {
  const { srcSetWebp, srcSetJpg } = buildSrcSets(base, widths);
  return (
    <picture>
      <source type="image/webp" srcSet={srcSetWebp} sizes={photoSizes} />
      <source type="image/jpeg" srcSet={srcSetJpg} sizes={photoSizes} />
      <img src={fallback} alt={alt} width={width} height={height} decoding="async" />
    </picture>
  );
}

function BookButton() {
  return <a className="home-button" href={text.bookingAgentLink}>{text.bookingAgentLabel}</a>;
}

function Home() {
  return (
    <div className="home">
      <div className="home-photos" aria-label="Fig Tree Cottage photos">
        {/* 1183px is this photo's full width */}
        <Photo
          base="Fig-Tree-Cottage-Front"
          widths={[480, 768, 1183]}
          fallback={require("../assets/Fig-Tree-Cottage-Front.jpg")}
          alt="The front of Fig Tree Cottage"
          width={1183}
          height={775}
        />
        <Photo
          base="PXL_20240401_073359261~2"
          widths={[480, 768, 1200]}
          fallback={`${process.env.PUBLIC_URL || ''}/images/optimized/PXL_20240401_073359261~2-w768.jpg`}
          alt="The sitting room with wood burner and garden doors"
          width={1200}
          height={900}
        />
      </div>

      <div className="home-cta">
        <BookButton />
        <p className="home-facts">{text.priceSignal}</p>
      </div>

      <section className="home-reviews" aria-label="Guest reviews">
        <a href="/reviews">{text.reviewHighlightsHeader}</a>
        {text.reviewHighlights.map((quote, idx) => <p key={idx}>{quote}</p>)}
      </section>

      <h1>{text.welcomeHeader}</h1>
      <p>{text.welcome}</p>

      <h2>{text.aboutHeader.replace(/:$/, '')}</h2>
      <p>{text.about}</p>
      <ul>
        {text.features.map((feature, idx) => <li key={idx}>{feature}</li>)}
      </ul>

      <h2>{text.highlightsHeader.replace(/:$/, '')}</h2>
      <p>{text.highlights}</p>

      <div className="home-end">
        <BookButton />
        <a className="home-facebook" href={text.facebookLink} target="_blank" rel="noopener noreferrer">
          {text.facebookLabel}
        </a>
      </div>
    </div>
  );
}

export default Home;
